import { combineReducers } from 'redux';
import loginDrawerReducer from './loginDrawer/loginDrawer.slice';

export default combineReducers({
  loginDrawer: loginDrawerReducer,
});
